export const darkGlass = {
  backgroundColor: 'hsla(0deg 0% 5% / 50%)',
  backdropFilter: 'blur(2px)',
};
